import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { API_BASE } from './App';
import { ThemeProvider } from './theme';
import { ToastProvider } from './ToastProvider';
import { JobsProvider } from './JobsProvider';
import { AuthProvider } from './AuthProvider';
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider apiBase={API_BASE}>
        <ToastProvider>
          <JobsProvider>
            <App />
          </JobsProvider>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
